import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  redirectUri: window.location.origin,
  responseType: 'token id_token',
  issuer: environment.oidc.discDocURL,
  strictDiscoveryDocumentValidation: false,
  clientId: environment.oidc.clientId,
  scope: environment.oidc.scope,
  skipIssuerCheck: true,
  clearHashAfterLogin: true,
  oidc: true
};
